<div id="table-container">
    <app-toolbar-table-view [title]="title"></app-toolbar-table-view>
    <app-project-info [description]="description" [deadline]="deadline" [collabs]="project.collaborators.length" [project]="project"></app-project-info> 
    <button id="flow-button" class="padder" (click)="createProject()">Add Project</button>
    <div class="scroll">
        <app-board-container [blockArray]="blockArray"></app-board-container>
    </div>
  
</div>